export { default } from "./src/embedded-video";

export type { UniformEmbeddedVideoProps } from "./src/embedded-video";
